// appointment.action.ts
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Clinic } from '@dataTypes/location.type'
import { newLocationData } from '@assets/mockdata'

export const fetchAllLocations = createAsyncThunk(
  'location/fetchAllLocations',
  async (): Promise<Clinic[]> => {
    return newLocationData // Ensure newLocationData has the correct structure.
  },
)

export const addLocation = createAsyncThunk(
  'location/addLocation',
  async (locationData: Clinic): Promise<Clinic> => {
    return locationData
  },
)

export const updateLocation = createAsyncThunk(
  'location/updateLocation',
  async (params: { id: string; updates: Partial<Clinic> }) => {
    return { id: params.id, body: params.updates }
  },
)

export const deleteLocation = createAsyncThunk(
  'location/deleteLocation',
  async (id: string) => {
    return id
  },
)
